<script>
  import AuthService from "./../authService.js";

  export let currentRoute;
  let name = currentRoute.name;
  var route_elements = name.split("/");
</script>

<header id="header" class="sticky-top">
  <!-- Navbar -->
  
  <nav
    class="primary-menu navbar navbar-expand-lg text-uppercase font-weight-500">
    <div
      class="container position-relative h-100 flex-lg-column
      justify-content-lg-center px-3 p-lg-4">
      <!-- Logo -->
      <a
        class="logo text-center d-lg-block mt-lg-3 mb-lg-4"
        href="/"
        title="Fiscalia Privada">
        <img src="/images/logo-fp-original.svg" alt="Fiscalia Privada" />
      </a>
      <!-- Logo End -->
      <hr class="d-none d-lg-block m-0 w-25" />
      <div id="header-nav" class="collapse navbar-collapse w-100">
        <ul class="navbar-nav my-lg-auto text-lg-center">
          {#if AuthService.isAuthenticated() && AuthService.isInformer()}
            <li class="nav-item">
              <a class="nav-link smooth-scroll active" href="/">Inicio</a>
            </li>
            <li class="nav-item">
              <a class="nav-link smooth-scroll" href="/denuncias">
                Mis denuncias / Asistencias Legales
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link smooth-scroll"
                href=""
                on:click={() => AuthService.logout()}>
                Cerrar sesión
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link smooth-scroll" target="_blank" href="https://fiscaliaprivada.cl/contacto/">Contacto</a>
            </li>
          {:else if AuthService.isAuthenticated() && AuthService.isLawyer()}
            <li class="nav-item">
              <a class="nav-link smooth-scroll active" href="/">Inicio</a>
            </li>
          {:else}
            <li class="nav-item">
              {#if route_elements[1] == 'fiscalia'}

                <a class="nav-link smooth-scroll active" href="/fiscalia">Inicio Fiscalía</a>

              {:else}

                <a class="nav-link smooth-scroll active" href="/">Inicio</a>

              {/if}

            </li>
            <li class="nav-item">
              <a class="nav-link smooth-scroll" href="/login">Iniciar sesión</a>
            </li>
            <li class="nav-item">
              <a class="nav-link smooth-scroll" target="_blank" href="https://fiscaliaprivada.cl/contacto/">Contacto</a>
            </li>
          {/if}
        </ul>
      </div>
      <hr class="d-none d-lg-block m-0 w-25" />
      <ul
        class="social-icons social-icons-sm mr-n1 mr-lg-0 mt-lg-4 d-none
        d-sm-flex">
        <li class="social-icons-facebook">
          <a
            data-toggle="tooltip"
            href="https://www.facebook.com/fiscaliaprivada"
            target="_blank"
            title=""
            data-original-title="Facebook">
            <i class="fab fa-facebook-f" />
          </a>
        </li>
        <li class="social-icons-twitter">
          <a
            data-toggle="tooltip"
            href="https://twitter.com/FiscaliaPrivada"
            target="_blank"
            title=""
            data-original-title="Twitter">
            <i class="fab fa-twitter" />
          </a>
        </li>
        <li class="social-icons-youtube">
          <a
            data-toggle="tooltip"
            href="https://www.youtube.com/channel/UCmuZMSF1yYC9UbbPe9qG-cw"
            target="_blank"
            title=""
            data-original-title="Youtube">
            <i class="fab fa-youtube" />
          </a>
        </li>
        <li class="social-icons-linkedin">
          <a
            data-toggle="tooltip"
            href="https://www.linkedin.com/company/fiscalia-privada/"
            target="_blank"
            title=""
            data-original-title="LinkedIn">
            <i class="fab fa-linkedin" />
          </a>
        </li>
        <li class="social-icons-instagram">
          <a
            data-toggle="tooltip"
            href="https://www.instagram.com/fiscaliaprivada/"
            target="_blank"
            title=""
            data-original-title="Instagram">
            <i class="fab fa-instagram" />
          </a>
        </li>
      </ul>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#header-nav">
        <span />
        <span />
        <span />
      </button>
    </div>
  </nav>
  <!-- Navbar End -->
</header>
